const isInternalToolErrorText = (value: string): boolean =>
  value.includes('Error invoking tool') ||
  value.includes('kwargs') ||
  value.includes('/node_modules/') ||
  /^\s*at\s+\S+/m.test(value) ||
  value.includes('Received tool input did not match expected schema');

export const resolveToolCallErrorDisplay = ({
  error,
  metadata,
}: {
  error?: string;
  metadata?: Record<string, unknown> | null;
}): string | undefined => {
  const errorLabelRaw = metadata?.['errorLabel'];
  const errorLabel =
    typeof errorLabelRaw === 'string' ? errorLabelRaw.trim() : '';
  if (errorLabel.length > 0) {
    return errorLabel;
  }

  const debugMessageRaw = metadata?.['debugMessage'];
  const debugMessage =
    typeof debugMessageRaw === 'string' ? debugMessageRaw.trim() : '';
  if (debugMessage.length > 0 && !isInternalToolErrorText(debugMessage)) {
    return debugMessage;
  }

  const fallback = typeof error === 'string' ? error.trim() : '';
  if (fallback.length > 0 && !isInternalToolErrorText(fallback)) {
    return fallback;
  }

  return errorLabel.length > 0 ? errorLabel : undefined;
};
